import classNames from 'classnames';

import './status-pill.scss';

export type StatusTone = 'pending' | 'error' | 'success' | 'neutral';

/*
 * Reads the tone off the status text, so every list can share the pill without
 * mapping its own status codes: anything erroring reads red, anything waiting
 * orange, anything finished green.
 */
export function toneForStatus(status = ''): StatusTone {
  const value = status.toLowerCase();

  if (/error|reject|fail/.test(value)) return 'error';
  if (/pending|waiting|progress/.test(value)) return 'pending';
  if (/clean|closed|approved|done|success|paid/.test(value)) return 'success';

  return 'neutral';
}

// Turns `open-pending` into `Open pending`.
function humanise(status: string): string {
  const spaced = status.replace(/[-_]+/g, ' ').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

interface StatusPillProps {
  status?: string | null;
  tone?: StatusTone;
}

export default function StatusPill({ status, tone }: StatusPillProps) {
  if (!status) return <>N/A</>;

  return (
    <span
      className={classNames(
        'status-pill',
        `status-pill--${tone ?? toneForStatus(status)}`
      )}
    >
      <span className="status-pill__dot" aria-hidden="true" />
      {humanise(status)}
    </span>
  );
}
